import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthLoadingScreen } from "../../components";
import { useActiveContext } from "../../contexts/ActiveContextContext";
import { useAuth } from "../../contexts/AuthContext";
import { rememberPostLoginPath } from "../../shared/postLoginRedirect";

export interface ProtectedRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  adminOnly = false,
}) => {
  const { isAuthenticated, user, token, isLoading: isAuthLoading } = useAuth();
  const { isLoading: isContextLoading } = useActiveContext();
  const location = useLocation();

  // Se o contexto ainda não tem os dados mas o localStorage tem, aguardar
  const [checkingStorage, setCheckingStorage] = React.useState(false);

  React.useEffect(() => {
    if (!isAuthLoading && !isAuthenticated && !user && !token) {
      const savedToken = localStorage.getItem("access_token");
      const savedUser = localStorage.getItem("user");
      if (savedToken && savedUser) {
        setCheckingStorage(true);
        // Dar um momento para o contexto atualizar
        setTimeout(() => setCheckingStorage(false), 100);
      }
    }
  }, [isAuthLoading, isAuthenticated, user, token]);

  if (isAuthLoading || isContextLoading || checkingStorage) {
    return (
      <AuthLoadingScreen message="Verificando autenticação e contexto..." />
    );
  }

  if (!isAuthenticated || !user || !token) {
    // Veio do menu de aplicações (/launch/<app>): retoma depois do login
    rememberPostLoginPath(location.pathname);
    return <Navigate to="/auth" replace />;
  }

  // Rotas admin: superusuário Virtus (role === 'admin' ou is_admin === true)
  if (adminOnly && user.role !== "admin" && !user.is_admin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
